var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "edit-strategy-dialog",
      attrs: {
        title: "新增&编辑内容",
        visible: _vm.dialogIsShow,
        width: "1000px",
        "append-to-body": true,
        "destroy-on-close": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogIsShow = $event
        },
        open: _vm.openCallback,
        close: _vm.closeCallback,
      },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-body" },
        [
          _c(
            "el-scrollbar",
            { staticClass: "main-part" },
            [
              _c(
                "el-form",
                {
                  ref: "formRef1",
                  staticClass: "dialog-form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "100px",
                    rules: _vm.formRule,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "策略名称", prop: "strategyName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入策略名称" },
                        model: {
                          value: _vm.form.strategyName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "strategyName", $$v)
                          },
                          expression: "form.strategyName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "info-box" }, [
                _c("div", { staticClass: "box-header" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("策略命中配置")]),
                ]),
                _c(
                  "div",
                  { staticClass: "box-body" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "formRef2",
                        staticClass: "dialog-form",
                        attrs: {
                          model: _vm.form,
                          "label-width": "100px",
                          rules: _vm.formRule,
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "渠道选择",
                              prop: "channelSelectionType",
                            },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-radio",
                                  {
                                    attrs: { label: 1 },
                                    model: {
                                      value: _vm.form.channelSelectionType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "channelSelectionType",
                                          $$v
                                        )
                                      },
                                      expression: "form.channelSelectionType",
                                    },
                                  },
                                  [_vm._v("全部渠道")]
                                ),
                                _c(
                                  "el-radio",
                                  {
                                    attrs: { label: 2 },
                                    model: {
                                      value: _vm.form.channelSelectionType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "channelSelectionType",
                                          $$v
                                        )
                                      },
                                      expression: "form.channelSelectionType",
                                    },
                                  },
                                  [_vm._v("指定渠道")]
                                ),
                              ],
                              1
                            ),
                            _vm.form.channelSelectionType === 2
                              ? _c("el-input", {
                                  attrs: { type: "textarea" },
                                  on: { focus: _vm.channelInputClick },
                                  model: {
                                    value: _vm.form.channelStr,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "channelStr", $$v)
                                    },
                                    expression: "form.channelStr",
                                  },
                                })
                              : _vm._e(),
                            _c("channel-popups", {
                              attrs: {
                                isAppendToBody: true,
                                modelIsAppendToBody: false,
                                "app-id": _vm.form.channels
                                  .map((item) => item.channelId)
                                  .join(","),
                                visible: _vm.channelVisible,
                                multiple: true,
                              },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.channelVisible = $event
                                },
                                comfirm: _vm.channelConfirm,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "APK版本范围",
                              prop: "apkVersionType",
                            },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-radio",
                                  {
                                    attrs: { label: 1 },
                                    model: {
                                      value: _vm.form.apkVersionType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "apkVersionType",
                                          $$v
                                        )
                                      },
                                      expression: "form.apkVersionType",
                                    },
                                  },
                                  [_vm._v("全部版本")]
                                ),
                                _c(
                                  "el-radio",
                                  {
                                    attrs: { label: 2 },
                                    model: {
                                      value: _vm.form.apkVersionType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "apkVersionType",
                                          $$v
                                        )
                                      },
                                      expression: "form.apkVersionType",
                                    },
                                  },
                                  [_vm._v("指定版本")]
                                ),
                              ],
                              1
                            ),
                            _vm.form.apkVersionType === 2
                              ? _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { "margin-right": "16px" },
                                      attrs: { min: 0 },
                                      model: {
                                        value: _vm.form.minApkVersion,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "minApkVersion",
                                            $$v
                                          )
                                        },
                                        expression: "form.minApkVersion",
                                      },
                                    }),
                                    _c("el-input-number", {
                                      attrs: { min: 0 },
                                      model: {
                                        value: _vm.form.maxApkVersion,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "maxApkVersion",
                                            $$v
                                          )
                                        },
                                        expression: "form.maxApkVersion",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "指定UID", prop: "specifiedUids" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "多个用英文逗号隔开",
                                type: "textarea",
                              },
                              model: {
                                value: _vm.form.specifiedUids,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "specifiedUids", $$v)
                                },
                                expression: "form.specifiedUids",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "info-box" },
                [
                  _c(
                    "div",
                    { staticClass: "box-header" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("关联导航配置"),
                      ]),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "16px" },
                          attrs: { plain: "", size: "small" },
                          on: { click: _vm.addNavigationTab },
                        },
                        [_vm._v("添加导航")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "16px" },
                          attrs: { plain: "", size: "small" },
                          on: { click: _vm.addMeetingNavigationTab },
                        },
                        [_vm._v("添加会议导航")]
                      ),
                    ],
                    1
                  ),
                  _vm._l(_vm.form.navigationItems, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        class: [
                          "box-body",
                          item.navigationCategory === 2
                            ? "meeting-navigation-box"
                            : "",
                        ],
                      },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "formRef3",
                            refInFor: true,
                            staticClass: "dialog-form",
                            attrs: {
                              model: _vm.form,
                              "label-width": "120px",
                              rules: _vm.formRule,
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "导航背景图",
                                  prop: "categoryBackgroundImageUrl",
                                },
                              },
                              [
                                _c("lb-img-uploader", {
                                  staticClass: "img-uploader",
                                  model: {
                                    value: item.categoryBackgroundImageUrl,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        item,
                                        "categoryBackgroundImageUrl",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "item.categoryBackgroundImageUrl",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._l(
                              item.navigations,
                              function (navigationId, navigationIndex) {
                                return _c(
                                  "el-form-item",
                                  {
                                    key: navigationId,
                                    attrs: {
                                      label: `导航tab${navigationIndex + 1}`,
                                      required: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "navigation-tab-container",
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              placeholder: "请选择",
                                            },
                                            model: {
                                              value:
                                                item.navigations[
                                                  navigationIndex
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item.navigations,
                                                  navigationIndex,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.navigations[navigationIndex]",
                                            },
                                          },
                                          _vm._l(
                                            _vm.navigationOptions,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.id,
                                                attrs: {
                                                  label: `(${item.id}) ${item.navgationTitle}`,
                                                  value: item.id,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-button",
                                            attrs: {
                                              type: "text",
                                              icon: "el-icon-delete",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteNavigationTab(
                                                  index,
                                                  navigationIndex
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
              _c(
                "el-form",
                {
                  ref: "formRef4",
                  staticClass: "dialog-form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "100px",
                    rules: _vm.formRule,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入备注",
                          type: "textarea",
                          maxlength: 999,
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.form.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status",
                          },
                        },
                        [_vm._v("生效")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0 },
                          model: {
                            value: _vm.form.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status",
                          },
                        },
                        [_vm._v("失效")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "button-container" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmEdit } },
                [_vm._v("保存")]
              ),
              _c("el-button", { on: { click: _vm.cancelEdit } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }